<router-outlet></router-outlet>

<app-esteira-desenvolvimento [environment]="environment"></app-esteira-desenvolvimento>
